(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tkb-card', {
            parent: 'entity',
            url: '/tkb-card?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.tkbCard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-card/tkb-cards.html',
                    controller: 'TkbCardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                userPhone: null,
                externalId: null,
                gateway: 'ALL',
                owner: null,
                cardNumber: null,
                referenceId: null,
                state: -1,
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        userPhone: $stateParams.userPhone,
                        externalId: $stateParams.externalId,
                        gateway: $stateParams.gateway,
                        owner: $stateParams.owner,
                        cardNumber: $stateParams.cardNumber,
                        referenceId: $stateParams.referenceId,
                        state: $stateParams.state,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbCard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tkb-card-detail', {
            parent: 'tkb-card',
            url: '/tkb-card/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'bozorakaAdminApp.tkbCard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tkb-card/tkb-card-detail.html',
                    controller: 'TkbCardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tkbCard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TkbCard', function($stateParams, TkbCard) {
                    return TkbCard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tkb-card',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tkb-card-detail.edit', {
            parent: 'tkb-card-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-dialog.html',
                    controller: 'TkbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbCard', function(TkbCard) {
                            return TkbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-card.new', {
            parent: 'tkb-card',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-dialog.html',
                    controller: 'TkbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                orderId: null,
                                externalId: null,
                                state: null,
                                referenceId: null,
                                number: null,
                                expireYear: null,
                                expireMonth: null,
                                owner: null,
                                provider: null,
                                statusCode: null,
                                message: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tkb-card', null, { reload: 'tkb-card' });
                }, function() {
                    $state.go('tkb-card');
                });
            }]
        })
        .state('tkb-card.edit', {
            parent: 'tkb-card',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-dialog.html',
                    controller: 'TkbCardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TkbCard', function(TkbCard) {
                            return TkbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-card', null, { reload: 'tkb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tkb-card.delete', {
            parent: 'tkb-card',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tkb-card/tkb-card-delete-dialog.html',
                    controller: 'TkbCardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TkbCard', function(TkbCard) {
                            return TkbCard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tkb-card', null, { reload: 'tkb-card' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
